import React, { useRef } from 'react'
import { ReactComponent as IconAlert } from "assets/images/icons/project-icons/alert-square.svg";
import logo from "assets/images/icons/project-icons/logo.png"
// import transactionQr from "assets/images/icons/transaction-qr.svg"
import transactionQr from "assets/images/icons/qr-code.svg"
import { ReactComponent as IconDebit } from "assets/images/icons/project-icons/arrow-up-right.svg";
import { ReactComponent as IconCredit } from "assets/images/icons/project-icons/arrow-down-left.svg";
import FormDrawer from './form-drawer';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import TransactionsPrintFooter from './TransactionsPrintFooter'


const TransactionDetailsWrapper = ({children, title, subtitle, isOpen, setIsOpen, amount, status, documentTitle, isCredit, noBottomRule, padFooter}) => {
    const printComponentRef = useRef();
    
    const isSuccessful = status === 'successful';
    const isPending = status === 'pending';
    const isFailed = status === 'failed'
    
    
    const handlePrint = useReactToPrint({
        content: () => printComponentRef.current,
        documentTitle,
    });
    
    const generateReceipt = () => {
        if (printComponentRef){
            handlePrint();
        } else {
            toast.error("Section to print is not specified");
        }
    }
    
    return (
        <>
        <div className="">
            <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}
            
            >
                <div className="px-6 py-4">
                    <FormDrawer.Title
                            title=""
                            showCloseButton={true}
                            close={setIsOpen}
                        />
                </div>
                <div className='w-full -mt-6 p-7 pb-2' 
                // ref={printComponentRef}
                >
                    <div className="w-full flex items-center justify-between">
                        
                        <div className="lg:text-lg font-bold">
                            Transaction Details
                        </div>
                        
                        <div className="w-28">
                            <img src={logo} alt="icon" />
                        </div>
                    </div>
                    <div className="w-full rounded-xl mt-4 border border-gray-300 flex items-center justify-between px-2">
                        
                        <div className="flex items-center text-sm my-2">
                            
                            <div className={`w-8 h-8 mr-3 flex rounded-full flex-shrink-0 ${!isCredit ? "bg-[#FEF2F2]" : "bg-[#cfffe3]"}`}>
                                {!isCredit ? <IconDebit className="m-auto" /> : <IconCredit className="m-auto" />}
                            </div>
                                
                            <div>
                                <p className="text-ep-gray-500 mb-0 capitalize">{title}</p>
                                <p className="text-ep-gray-700 mb-0">{subtitle}</p>
                            </div>
                        </div>
                        
                        <div className="font-medium text-lg text-ep-gray-700">
                            {amount}
                        </div>
    {/*                     
                        <dir className="font-medium text-lg text-ep-gray-700">
                            {amount}
                        </dir> */}
                        
                    </div>
                    
                    <div className="w-full">
                        <div className="w-full flex items-center justify-between text-sm mt-7">
                            <div className="text-ep-gray-500">Status</div>
                            <div className={`text-sm capitalize label pb-1 ${isSuccessful ? 'label-green' : isPending ? 'label-yellow' : isFailed ? 'label-red' : ''}`}>
                                {status}
                            </div>
                        </div>
                        {children}
                    </div>
                    
                </div>
                
                <div className={`${!noBottomRule && 'border-t'} flex items-center justify-center w-full p-5 pb-7`}>
                    <a href="mailto:support@earnipay.com" rel="noreferrer" target="_blank"
                        style={{padding: '14px 16px'}}
                        className="text-[#dc2626] font-medium border border-[#dc2626] flex items-center w-max rounded-lg text-sm decoration-none">
                        Report an Issue
                        <span className="ml-2 mb-px"><IconAlert width={18} /></span>
                    </a>
                    
                    <button onClick={generateReceipt} className= "btn btn-ep-primary font-medium text-sm ml-4" style={{padding: '14px 16px'}}>
                        Download Receipt
                    </button>
                </div>
                    
            </FormDrawer>
        </div>
        <div className="relative bg-ep-gray-100 hidden print:block p-6 " ref={printComponentRef}>
            {/* <FormDrawer display="center" size="lg" isOpen={false} setIsOpen={setIsOpen}
            
            > */}
                <div className="w-full flex justify-center pb-6">
                    <img src={logo} width="184.75px text-center" alt="icon" />
                </div>
                <div className="bg-white py-6 rounded-lg">
                <div className='w-full -mt-6 p-7 pb-2' >
                    <div className="w-full flex items-center justify-between">
                        
                        <div className="lg:text-lg font-bold">
                            Transaction Details
                        </div>
                        
                        {/* <div className="w-28">
                            <img src={logo} alt="icon" />
                        </div> */}
                    </div>
                    <div className="w-full rounded-xl mt-4 border border-gray-300 flex items-center justify-between px-2">
                        
                        <div className="flex items-center text-sm my-2">
                            
                            <div className={`w-8 h-8 mr-3 flex rounded-full flex-shrink-0 ${!isCredit ? "bg-[#FEF2F2]" : "bg-[#cfffe3]"}`}>
                                {!isCredit ? <IconDebit className="m-auto" /> : <IconCredit className="m-auto" />}
                            </div>
                                
                            <div>
                                <p className="text-ep-gray-500 mb-0 capitalize">{title}</p>
                                <p className="text-ep-gray-700 mb-0">{subtitle}</p>
                            </div>
                        </div>
                        
                        <div className="font-medium text-lg text-ep-gray-700">
                            {amount}
                        </div>
    {/*                     
                        <dir className="font-medium text-lg text-ep-gray-700">
                            {amount}
                        </dir> */}
                        
                    </div>
                    
                    <div className="w-full">
                        <div className="w-full flex items-center justify-between text-sm mt-7">
                            <div className="text-ep-gray-500">Status</div>
                            <div className={`text-sm capitalize label pb-1 ${isSuccessful ? 'label-green' : isPending ? 'label-yellow' : isFailed ? 'label-red' : ''}`}>
                                {status}
                            </div>
                        </div>
                        {children}
                    </div>
                    
                </div>
                
                </div>
                <div className="bg-white p-6 my-6 rounded-lg">
                    <div className="flex flex-col gap-4">
                        <p className="text-center text-lg font-medium">Get Earnipay For Individuals</p>
                        <div className="w-full flex justify-center"><img src={transactionQr} className="text-center" alt="qr code" width={"135px"} height={"135px"} /></div>
                        <div className="flex justify-center ">
                            <div className="flex items-center gap-2">
                                <hr className="bg-ep-gray-100" style={{width: '65px'}} />
                                <p className="center text-lg font-medium">OR</p>
                                <hr className="bg-ep-gray-100" style={{width: '65px'}} />
                            </div>
                        </div>
                        <div className="bg-ep-gray-100 rounded-xl py-4">
                            <p className="text-center text-base text-ep-gray-300 mb-2 font-medium">Click on the link below</p>
                            <p className="w-full flex justify-center"><a href='https://onelink.to/vazvk5' className="text-center text-base text-ep-primary-600 underline font-normal">https://onelink.to/vazvk5</a></p>
                        </div>
                    </div>
                </div>
                {padFooter && <div style={{padding: padFooter}} />}
                <div className="print-footer hidden print:block w-full bg-transparent pb-6">
                    <TransactionsPrintFooter />
                </div>
                
            {/* </FormDrawer> */}
        </div>
        </>
        
    )
}

export default TransactionDetailsWrapper
